import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
declare var $: any;

@Component({
  selector: 'question-side-menu',
  templateUrl: './question-side-menu.component.html',
  styleUrls: ['./question-side-menu.component.css']
})
export class QuestionSideMenuComponent implements OnInit {
  @Input() questionList:any;
  @Input() isReading:boolean=false;
  
  @Output() onSelectedQuestion: any = new EventEmitter<any>();
  
  public activeIndex:number=0;

  constructor() { }

  ngOnInit() {
  }

  openSideBar(){
    document.getElementById("question-sidebar").style.width = "250px";
  }

  closeNav() {
    document.getElementById("question-sidebar").style.width = "0";
  }

  onSelected(ques,index){
    this.activeIndex=index;
    this.onSelectedQuestion.emit(ques);
    this.closeNav();
  }
}


